import React from "react";
import { Button } from "@sparkol/videoscribe-react-ui";
import { useStore } from "@nanostores/react";
import { currentUser } from "../../../store";

const FreeTrialGoToAppButton = () => {
  const user = useStore(currentUser);
  const label = user ? "Go to app" : "Start free trial";
  const href = user ? "/app" : "/free-trial";

  return (
    <Button href={href} fullWidth>
      {label}
    </Button>
  );
};

export default FreeTrialGoToAppButton;
